import React from 'react';
import './App.css';
import { slide as Menu } from 'react-burger-menu';
import { Icon } from 'semantic-ui-react';

const _p = atob('L21l');

function Menu_({lang, toggleLang, darkMode, toggleDarkMode, menuOpen, setMenuOpen, isPublic}) {
  return (
    <div>
    <Menu pageWrapId={ "page-wrap" } outerContainerId={ "outer-container" }
      isOpen={menuOpen}
      onStateChange={(state) => setMenuOpen(state.isOpen)}>
      <a className='menu-item' href={isPublic ? '/' : _p}>
        <span> <Icon name='home' /> </span>
        <span> {lang ? '首页' : 'Home'} </span>
      </a>
      <a className='menu-item' href='https://github.com/ericpzh'>
        <span> <Icon name='github' /> </span>
        <span> Github </span>
      </a>
      <a className='menu-item' href={isPublic ? 'mailto:someone@gmail.com' : 'mailto: ericpzhpuma@gmail.com'}>
        <span> <Icon name='mail' /> </span>
        <span> {lang ? '邮箱' : 'Email'} </span>
      </a>
      <a className='menu-item' onClick={toggleDarkMode}>
        <span> <Icon name={darkMode ? 'sun' : 'moon'} /> </span>
        <span> {lang ? (darkMode ? '浅色模式' : '深色模式') : (darkMode ? 'Light Mode' : 'Dark Mode')} </span>
      </a>
      <a className='menu-item' onClick={() => toggleLang(!lang)}>
        <span> <Icon name='language' /> </span>
        <span> {lang ? 'English' : '中文'} </span>
      </a>
    </Menu>
    </div>
  )
}

export default Menu_;
